module.exports = __webpack_public_path__ + "static/media/tiketcom-logo-icon-1.1db40ad5.png";